import { makeObservable, observable } from 'mobx';
import { getWindow } from './getWindow';

export type TDirection = 'up' | 'both' | 'down';
const controller: {
  direction: TDirection | '';
} = {
  direction: '',
};
makeObservable(controller, { direction: observable });

function initScrollController() {
  if (typeof window === 'undefined' || controller.direction !== '') return;
  controller.direction = 'both';

  function setShouldShow(direction: TDirection) {
    controller.direction = direction;
  }

  const resizeObserver = new ResizeObserver(() => {
    if (document.documentElement.scrollHeight === getWindow().innerHeight)
      controller.direction = 'both';
  });

  resizeObserver.observe(document.documentElement);
  let currentScroll = document.documentElement.scrollTop;

  function handleScroll() {
    const direction = controller.direction;
    if (
      document.documentElement.scrollTop > currentScroll &&
      direction !== 'down'
    ) {
      setShouldShow('down');
    } else if (
      document.documentElement.scrollTop < currentScroll &&
      direction !== 'up'
    ) {
      setShouldShow('up');
    }
    currentScroll = document.documentElement.scrollTop;
  }

  document.addEventListener('scroll', handleScroll);

  return () => {
    resizeObserver.disconnect();
    document.removeEventListener('scroll', handleScroll);
  };
}
initScrollController();

export default function useMatchScrollDirection(direction: 'up' | 'down') {
  return controller.direction === 'both' || controller.direction === direction;
}
